import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IAttributes, IAugmentedJQuery, IController, IModule, IOnChangesObject, IPromise, IQService, IScope, ITimeoutService} from "angular";
import {StateService} from "@uirouter/angularjs";
import {DokumentFormatInfo, DokumentInformasjon, DokumentRessurs} from "felles/tjenester/ressurser/DokumentRessurs";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {SøkRessurs} from "felles/tjenester/ressurser/SøkRessurs";
import {ModelloppdateringTjeneste} from "web/tjenester/ModelloppdateringTjeneste";
import {FavorittTjeneste} from "felles/tjenester/modulspesifikke/FavorittTjeneste";
import {Filer} from "felles/tjenester/Filer";
import {Dialog} from "../../../../tjenester/Dialog";
import {ArkivRessurs} from "felles/tjenester/ressurser/ArkivRessurs";
import {Debugger} from "debug";
import {PdfjsMelding, PdfjsMeldingshåndtering} from "felles/tjenester/PdfjsMeldingshåndtering";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {DokumentsigneringRessurs} from "felles/tjenester/ressurser/DokumentsigneringRessurs";
import {VisSkjermingDialog} from "../../modale/visSkjermingDialog/visSkjermingDialog";
import {DokumentsignatarerDialog} from "../../modale/dokumentsignatarer/dokumentsignatarerDialog";
import {AvsluttSigneringsprosessDialog} from "../../modale/avsluttSigneringsprosess/avsluttSigneringsprosessDialog";
import {AgendadokumentValgDialog} from "web/moduler/møte/modale/agendaDokumentValg/agendaDokumentValgDialog";
import {ForfalteOppgaverDokumentValgDialog} from "web/moduler/møte/modale/forfalteOppgaverDokumentValg/forfalteOppgaverDokumentValgDialog";
import {erIkkeNill} from "felles/stoettefunk/nillsjekk";
import {scrollTilTopp} from "felles/stoettefunk/scroll";
import {Ng2DialogTjenesterForAjs, SaksdokumentDatatjenesteForAjs} from "web/nedgraderteNg2Tjenester";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";
import {kopierFraAjsTilNg2} from "felles-ng2/modell/ajsNg2ModellBroer";
import TilgangsrolleMedlem = l.TilgangsrolleMedlem;
import DokumentType = l.DokumentType;

const debug: Debugger = require('debug')('DokumentKontroller');


export class DokumentKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmMoeteDokument', {
                bindings: {
                    dokument: '<',
                    redigeringMulig: '<',
                    versjonsvisningStoettet: '<', //defaulter til sann
                    liknendedokumenterStoettet: '<', //defaulter til sann
                    behandlesISakerStoettet: '<', //defaulter til sann
                    favorittmarkeringStoettet: '<', //defaulter til sann
                    signeringStoettet: '<', //defaulter til sann
                    visForsideBilde: '<', //defaulter til sann
                    vedFlytt: '&',
                    vedSlett: '&',
                    vedNyVersjon: '&',
                    vedVisPreview: '&',
                    vedSkjulPreview: '&'
                },
                controller: DokumentKontroller.forInjisering(),
                template: require('./dokument.html')
            })
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.$attrs,
            regNavn.ng.ui.$state,
            regNavn.ng.$element,
            regNavn.ng.$timeout,
            regNavn.ng.$q,
            regNavn.md.$mdDialog,
            Kontekst.regNavn,
            DokumentRessurs.regNavn,
            SøkRessurs.regNavn,
            ArkivRessurs.regNavn,
            DokumentsigneringRessurs.regNavn,
            ModelloppdateringTjeneste.regNavn,
            PdfjsMeldingshåndtering.regNavn,
            FavorittTjeneste.regNavn,
            Dialog.regNavn,
            WebNavigasjon.regNavn,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            ng2RegNavn.SaksdokumentDatatjenesteForAjs,
            ng2RegNavn.Ng2DialogTjenesterForAjs,
            DokumentKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $attr: IAttributes,
                private $state: StateService,
                private $element: IAugmentedJQuery,
                private $timeout: ITimeoutService,
                private $q: IQService,
                private $mdDialog: angular.material.IDialogService,
                private kontekst: Kontekst,
                private dokumentRes: DokumentRessurs,
                private søkRes: SøkRessurs,
                private arkivRes:ArkivRessurs,
                private dokumentsigneringRessurs: DokumentsigneringRessurs,
                private modelloppdatering: ModelloppdateringTjeneste,
                private pdfjsMeldingshåndtering: PdfjsMeldingshåndtering,
                private favorittTjeneste: FavorittTjeneste,
                private dialog: Dialog,
                private navigasjon: WebNavigasjon,
                private meldingTilBruker: MeldingTilBruker,
                private gettextCatalog: gettextCatalog,
                private saksdokumentDatatjenesteForAjs: SaksdokumentDatatjenesteForAjs,
                private ng2DialogTjenesterForAjs: Ng2DialogTjenesterForAjs) {
        this.lyttTilDokumentVirussjekket();
        this.lyttTilDokumentKonvertertPdf();
        this.lyttTilDokumentForsidebildeOpprettet();
        this.lyttTilNyDokumentAnnotering();
        this.lyttTilDokumentAnnoteringSlettet();
        this.lyttTilDokumentTilSignering();
        this.lyttTilDokumentKomplettSignert();
        this.lyttTilDokumentLåstOpp();
    }

    dokument: l.DokumentVersjonModell; //settes via bindings/$onChanges
    redigeringMulig: boolean; //settes via bindings/$onChanges
    forespurtAnnoteringId: string = null;
    versjonsvisningStoettet: boolean; //settes via bindings/$onChanges
    liknendedokumenterStoettet: boolean; //settes via bindings/$onChanges
    behandlesISakerStoettet: boolean; //settes via bindings/$onChanges
    favorittmarkeringStoettet: boolean; //settes via bindings/$onChanges
    signeringStoettet: boolean; //settes via bindings/$onChanges
    visForsideBilde: boolean; //settes via bindings/$onChanges
    vedFlytt: (arg: { dokument: l.DokumentVersjonModell; }) => any; //settes via bindings
    vedSlett: (arg: { dokument: l.DokumentVersjonModell; }) => any; //settes via bindings
    vedNyVersjon: (arg: { dokument: l.DokumentVersjonModell; filer: File[]; }) => any; //settes via bindings
    vedVisPreview: (arg: { dokument: l.DokumentVersjonModell; }) => any; //settes via bindings
    vedSkjulPreview: (arg: { dokument: l.DokumentVersjonModell; }) => any; //settes via bindings

    dokumentinformasjon: DokumentInformasjon;
    skalSigneresAvBruker = false;
    antattStoettedeSigneringsmetoder: l.Signeringsmetode[];
    private signatar: l.DokumentSignatarModell;
    stoetterPreview = false;
    erVisPreview = false;
    forsidetype: string;

    visVersjoner = false;
    dokumentVersjoner: l.DokumentVersjonModell[];

    visLiknende = false;
    liknendeDokumenter: l.LiknendeDokumentModell[];
    private pdfjsMeldingshåndteringRegistrert = false; //for å sikre at vi reg meldingslytter kun én gang

    visSakerArkivdokumentetBehandlesI = false;
    dokumentVersjonerOgSaker:l.DokumentVersjonOgSakerModell[];

    previewDokumenterISubliste: { [key: string]: boolean; } = {};

    viserMenypunktFlytt() {
        return this.$attr['vedFlytt'] && this.redigeringMulig;
    }

    viserMenypunktSlett() {
        return this.$attr['vedSlett'] && this.redigeringMulig;
    }

    viserMenypunktNyVersjon() {
        return this.$attr['vedNyVersjon'] &&
            this.dokumentinformasjon &&
            !this.dokumentinformasjon.erProtokolldokumentISak &&
            this.redigeringMulig &&
            this.dokument.signeringStatus == l.SigneringStatus.ikkeAktivert;
    }

    viserMenypunktSendTilSignering() {
        return this.signeringStoettet !== false &&
            this.dokument.signeringStatus == l.SigneringStatus.ikkeAktivert &&
            this.kontekst.inneharTilgangsrolleIGruppe(TilgangsrolleMedlem.skrive, this.dokument.gruppeId);
    }

    viserMenypunktVisSignatarer() {
        return this.signeringStoettet !== false &&
            this.dokument.signeringStatus != l.SigneringStatus.ikkeAktivert;
    }

    viserMenypunktMarkerSomFerdigSignert() {
        return this.signeringStoettet !== false &&
            this.dokument.signeringStatus == l.SigneringStatus.delvisSignert;
    }

    viserMenypunktVisVersjoner() {
        return this.versjonsvisningStoettet !== false &&
            this.dokument && this.dokument.versjonsnummer > 1;
    }

    viserMenypunktVisLiknendeDokumenter() {
        return this.liknendedokumenterStoettet !== false;
    }

    viserMenypunktVisBehandlesISaker(){
        return this.behandlesISakerStoettet !== false &&
            this.dokument &&
            (this.dokument.type === l.DokumentType.arkivdokumentISak || this.dokument.type === l.DokumentType.arkivdokument);
    }

    viserMenypunktVisIArkiv(){
        return this.dokument && this.dokument.type === l.DokumentType.arkivdokumentISak;
    }

    viserMenypunktFavorittMarkering(){
        return this.favorittmarkeringStoettet !== false;
    }

    viserMenypunktOppdaterSkjerming(){
        if (!this.dokument) return false;
        if (this.erSkjermbartSaksdokument()) return true;
        return this.dokument.type === l.DokumentType.arkivdokument;
    }

    viserMenypunktAppneIGoogleDrive(){
        if (!this.dokument) return false;
        return !_.isEmpty(this.dokument.googleDriveUrl);
    }

    viserMenypunktAppneIMicrosoftOneDrive(){
        if (!this.dokument) return false;
        return !_.isEmpty(this.dokument.microsoftOneDriveUrl);
    }

    viserVelgDokumentInnhold() {
        return erIkkeNill(this.dokument) &&
          this.kontekst.inneharTilgangsrolleIGruppe(TilgangsrolleMedlem.skrive, this.dokument.gruppeId) &&
          (this.dokument.type === l.DokumentType.generertAgendaDokument || this.dokument.type === l.DokumentType.generertForfalteOppgaverDokument );
    }

    velgDokumentInnhold() {
        if(this.dokument.type === l.DokumentType.generertAgendaDokument) {
            return this.velgAgendaDokumentInnhold();
        }
        if(this.dokument.type === l.DokumentType.generertForfalteOppgaverDokument) {
            return this.velgForfalteOppgaverDokumentInnhold();
        }
    }

    private velgAgendaDokumentInnhold() {
        AgendadokumentValgDialog.visAgendadokumentValgDialog(this.$mdDialog, this.dokument.gruppeId)
            .then(() => {
                if(this.erVisPreview) {
                    this.lukkPreview();
                    this.$timeout(() => {this.visPreview()}, 300);
                }
            })
            .catch(()=>{}); //bruker avbrøt'
    }

    private velgForfalteOppgaverDokumentInnhold() {
        ForfalteOppgaverDokumentValgDialog.visForfalteOppgaverDokumentValgDialog(this.$mdDialog, this.dokument.gruppeId)
            .then(() => {
                if(this.erVisPreview) {
                    this.lukkPreview();
                    this.$timeout(() => {this.visPreview()}, 300);
                }
            })
            .catch(()=>{}); //bruker avbrøt'
    }


    aapneSom(formatInfo: DokumentFormatInfo, åpneIPdfjs = true) {
        //todo kai des 2016 - skal det være mulig å åpne ikke-sjekket dok? - vise advarsel?
        if (this.dokument.virussjekkStatus == l.VirussjekkStatus.infisert) {
            this.dialog.alert(
                /// alert tittel vist ved åpning av virusinfisert dokument
                this.gettextCatalog.getString("Åpning av dokument forhindret"),
                /// alert melding vist ved åpning av virusinfisert dokument
                this.gettextCatalog.getString("Dokumentet er virusinfisert og kan derfor ikke åpnes"));
            return;
        }

        if (!this.dokument.erLestAv) this.markerDokumentSomLest();

        if (åpneIPdfjs == true && this.dokumentRes.støtterPdfjs()) {
            if (formatInfo.mimeinfo.mimetype === Filer.mimetyper.pdf.mimetype) {
                this.åpneIPdfjs();
                return;
            } else
                console.debug('kan ikke åpne ikke-pdf med pdfjs', formatInfo.mimeinfo.mimetype, formatInfo.url);
        }

        window.open(formatInfo.url, "_blank");
    }

    aapneIGoogleDrive(){
        window.open(this.dokument.googleDriveUrl, "_blank");
    }

    aapneIMicrosoftOneDrive(){
        window.open(this.dokument.microsoftOneDriveUrl, "_blank");
    }

    visPreview() {
        if (!this.dokument.harPdfRepresentasjon) return;
        this.erVisPreview = true;

        if (!this.dokument.erLestAv) this.markerDokumentSomLest();

        this.vedVisPreview({dokument: this.dokument});
        // trenger ikke gjøres hver gang man viser dokumentet - er nok at det er i menyen. Søket tar lang tid
        // this.liknendeDokumenter = this.søkRes.finnLiknendeDokumentversjoner(this.dokument.id);
        this.scrollTilPreview();
    }

    lukkPreview() {
        this.erVisPreview = false;
        this.vedSkjulPreview({dokument: this.dokument});
    }

    erVisPreviewISubliste() {
        return _(this.previewDokumenterISubliste).values().some(b => b === true);
    }

    erVisPreviewISublisteFor(dokument: l.DokumentVersjonModell) {
        return this.previewDokumenterISubliste[dokument.dokumentId] === true;
    }

    vedVisPreviewISubliste(dokument: l.DokumentVersjonModell) {
        this.previewDokumenterISubliste[dokument.dokumentId] = true;
        this.vedVisPreview({dokument: this.dokument});
    }

    vedSkjulPreviewISubliste(dokument: l.DokumentVersjonModell) {
        this.previewDokumenterISubliste[dokument.dokumentId] = false;
        //vedSkjulPreview kalles kun når ingen dok i sublisten lenger er i preview
        if (!this.erVisPreviewISubliste()) this.vedSkjulPreview({dokument: this.dokument});
    }

    private resetPreviewDokumenterISubliste() {
        this.previewDokumenterISubliste = {};
    }

    flytt() {
        this.vedFlytt({dokument: this.dokument});
    }

    slett() {
        this.vedSlett({dokument: this.dokument});
    }

    gaaTilProtokoll() {
        this.navigasjon.gåTilMøteProtokollFraProtokolldokumentISak(this.dokument.dokumentId);
    }

    registrerNyVersjon(filer: File[]) {
        if (!filer) return console.log("registrerSaksdokument", "ingen filer");
        this.vedNyVersjon({dokument: this.dokument, filer: filer});
    }

    visAlleVersjoner() {
        this.visVersjoner = true;
        this.dokumentVersjoner = this.dokumentRes.hentVersjoner(this.dokument.dokumentId);
    }

    lukkVersjonsvisning() {
        this.visVersjoner = false;
        this.resetPreviewDokumenterISubliste();
    }

    visLiknendeDokumenter() {
        this.søkRes.finnLiknendeDokumentversjoner(this.dokument.id).$promise
            .then(dokumenter => {
                if (dokumenter.length == 0) {
                    this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Fant ingen liknende dokumenter"));
                    return;
                }

                this.visLiknende = true;
                this.liknendeDokumenter = dokumenter;
            });
    }

    lukkLiknendevisning(){
        this.visLiknende = false;
        this.resetPreviewDokumenterISubliste();
    }

    visSakerArkivdokumentBehandlesI(){
        this.arkivRes.lastSakerKnyttetTilArkivdokument(this.dokument.dokumentId).$promise
            .then(dokumentVersjonerOgSaker =>{
                console.debug('dokumentVersjonerOgSaker', dokumentVersjonerOgSaker);
                if (dokumentVersjonerOgSaker.length == 0){
                    this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Dokumentet er ikke til behandling i noen saker"));
                    return;
                }

                this.visSakerArkivdokumentetBehandlesI = true;
                this.dokumentVersjonerOgSaker = dokumentVersjonerOgSaker;
            });
    }

    gaaTilArkivinnslag(){
        this.navigasjon.gåTilArkivdokumentKnyttetTilDokumentVersjon(this.dokument.id);
    }

    lukkSakerArkivdokumentBehandlesIvisning(){
        this.visSakerArkivdokumentetBehandlesI = false;
        this.resetPreviewDokumenterISubliste();
    }

    erFavoritt() {
        return this.favorittTjeneste.erFavoritt(this.dokument);
    }

    endreFavorittmarkering() {
        this.favorittTjeneste.endreFavorittmarkeringForDokumentversjon(this.dokument);
    }

    redigerSkjerming(){
        VisSkjermingDialog.visSkjermingDialog({
                entitetType: this.erSkjermbartSaksdokument() ? 'saksdokument' : 'arkivdokument',
                gruppeId: () => this.dokument.gruppeId,
                hentSkjerming: () => this.dokumentRes.hentSkjerming(this.dokument.dokumentId).$promise,
                oppdaterSkjerming: (spesifikasjon: l.OppdaterSkjermingSpesifikasjon) => this.dokumentRes.oppdaterSkjerming(this.dokument.dokumentId, spesifikasjon).$promise
            },
            this.$mdDialog);
        //@todo sørge for at modell oppdateres - møte må relastes for at wmMoeteSkjermetTips skal fungere ordentlig
    }

    sendTilSignering(){
        //signering kan ikke initieres for arkivdokumentISak - må gjøres fra arkivdokumentet
        if (this.dokument.type == DokumentType.arkivdokumentISak){
            this.dialog.confirm(
                this.gettextCatalog.getString('Signer biblioteksdokument'),
                this.gettextCatalog.getString('{{filnavn}} er et bibliotekdokument, du må gå til bibliotekinnslaget for å sende dette dokumentet til signering.', {filnavn: this.dokument.filnavn}),
                this.gettextCatalog.getString('Gå til bibliotekinnslaget'),
                this.gettextCatalog.getString('Avbryt'))
                .then(()=> this.gaaTilArkivinnslag());
            return;
        }
        //signering kan ikke initieres for protokolldokumentISak - må gjøres fra protokoll
        if (this.dokument.type == DokumentType.protokolldokumentISak){
            this.dialog.confirm(
                this.gettextCatalog.getString('Signer protokolldokument'),
                this.gettextCatalog.getString('{{filnavn}} er et generet protokolldokument, du må gå til protokollen for å sende dette dokumentet til signering.', {filnavn: this.dokument.filnavn}),
                this.gettextCatalog.getString('Gå til møteprotokoll'),
                this.gettextCatalog.getString('Avbryt'))
                .then(()=> this.gaaTilProtokoll());
            return;
        }
        //meld fra dersom dokument ikke kan signeres
        if (!this.dokument.harPdfRepresentasjon){
            this.dialog.alert(
                this.gettextCatalog.getString('Signering ikke mulig'),
                this.gettextCatalog.getString('{{filnavn}} finnes ikke i PDF-format og kan derfor ikke sendes til signering. Registrer en ny dokumentversjon i PDF-format for å kunne sende til seignering.', {filnavn: this.dokument.filnavn}),
            );
            return;
        }
        if (!_.includes([l.DokumentType.opplastetSaksdokument, l.DokumentType.arkivdokumentISak, l.DokumentType.arkivdokument], this.dokument.type)){
            this.dialog.alert(
                this.gettextCatalog.getString('Signering ikke mulig'),
                this.gettextCatalog.getString('Kun opplastede dokumenter kan signeres. Genererte dokumenter som agenda og beslutningsoppfølging kan ikke signeres.'),
            );
            return;
        }
        if (this.dokument.pdfFilstoerrelse > 1024 * 1024 * 10){ //må holdes i synk med no.systemfabrikken.lederplan.domene.dokument.Signering.MAKS_FILSTØRRELSE_SIGNERING
            this.dialog.alert(
                this.gettextCatalog.getString('Signering ikke mulig'),
                this.gettextCatalog.getString('{{filnavn}} er for stor til å kunne sendes til signering. Kun filer mindre enn 10 Mb kan signeres.', {filnavn: this.dokument.filnavn}),
            );
            return;
        }

        //vi send-til-signering-dialogen
        DokumentsignatarerDialog.visSendTilSigneringDialog(this.dokument, this.$mdDialog)
          .then(() => {
              this.kalkulerSkalSigneresAvBruker();
              //opppdater dokument
              this.oppdaterDokumentTilSenesteVersjon();
          })
          .catch(_.noop);
    }

    visSignatarer(){
        DokumentsignatarerDialog.visSignatarerDialog(this.dokument, this.$mdDialog)
          .then(() => {
              this.kalkulerSkalSigneresAvBruker();
              //opppdater dokument
              this.oppdaterDokumentTilSenesteVersjon();
          })
          .catch(_.noop);
    }

    markerSomFerdigSignert() {
        AvsluttSigneringsprosessDialog.visAvsluttSigneringsprosessDialog(this.dokument, this.$mdDialog)
          .then(() => {
              this.kalkulerSkalSigneresAvBruker();
              //opppdater dokument
              this.oppdaterDokumentTilSenesteVersjon();
          })
          .catch(_.noop);
    }

    signerDokument() {
        //signering kan ikke initieres for protokolldokumentISak - må gjøres fra protokoll
        if (this.dokument.type == DokumentType.protokolldokumentISak) {
            this.gaaTilProtokoll();
            return;
        }
        this.ng2DialogTjenesterForAjs.signerDokumentDialog(kopierFraAjsTilNg2(this.dokument), {signatar: kopierFraAjsTilNg2(this.signatar), antattStoettedeSigneringsmetoder: []})
          .then(signert => {
              if (signert) {
                  debug("visSignerDialog lukket", this.dokument);
                  this.kalkulerSkalSigneresAvBruker();
                  //oppdater dokument
                 // this.oppdaterDokumentTilSenesteVersjon(); //@todo er dette nødv?
              }
          })
          .catch(_.noop);
    }

    $onChanges(changes: IOnChangesObject) {
        dersomChangesInneholder(changes, 'dokument', (dokument:l.DokumentVersjonModell, gammelVerdi:l.DokumentVersjonModell) => {
            //debug('$onChanges dokument', changes);
            if (_.isObject(dokument) && _.isObject(gammelVerdi) && dokument.id === gammelVerdi.id) return; //av ukjent grunn trigges $onChanges flere ganger med samme dokument - forhindrer at feks signerDokument blir kalt multiple ganger
            this.initData(dokument).then(()=>{
                if (dokument.dokumentId === this.$state.params['dokumentId']) {
                    if (this.$state.params['signer'] === true){
                        //signering av dokument er forespurt
                        if (this.skalSigneresAvBruker && this.signeringStoettet !== false)
                            this.signerDokument();
                    } else {
                        //preview av dokument er forespurt
                        this.forespurtAnnoteringId = this.$state.params['forespurtAnnoteringId'];
                        this.visPreview();
                    }
                }
            });
        });
    }

    //private hjelpemetoder

    private initData(dokumentversjon: l.DokumentVersjonModell):IPromise<any> {
        this.dokument = dokumentversjon;
        this.dokumentinformasjon = this.dokumentRes.dokumentinformasjon(this.dokument);
        this.stoetterPreview = this.kalkulerStøtterPreview();
        this.forsidetype = this.kalkulerForsidetype();
        this.lyttTilPdfjsÅpneINyttVindu();
        return this.kalkulerSkalSigneresAvBruker();
    }

    private kalkulerSkalSigneresAvBruker():IPromise<boolean>{
        this.skalSigneresAvBruker = false;
        //spesialhåndtering av protokolldokumentISak - vis ikon for signering dersom bruker skal signere protokoll
        if (this.dokument.type == l.DokumentType.protokolldokumentISak)
            return this.signatarinformasjonForAktivBruker(this.dokument.foreldre.protokolldokumentId);

        if (this.dokument.signeringStatus == l.SigneringStatus.ikkeAktivert || this.dokument.signeringStatus == l.SigneringStatus.signert || this.dokument.signeringStatus == l.SigneringStatus.signertOgKonvoluttert)
            return this.$q.resolve(false);

        return this.signatarinformasjonForAktivBruker(this.dokument.dokumentId);
    }

    private signatarinformasjonForAktivBruker(dokumentId: string = this.dokument.foreldre.protokolldokumentId) {
        return this.dokumentsigneringRessurs.signatarinformasjonForAktivBruker(dokumentId).$promise
            .then(respons => {
                this.skalSigneresAvBruker = respons.signatarFunnet && !respons.signatar.harSignert;
                this.signatar = respons.signatar;
                this.antattStoettedeSigneringsmetoder = respons.antattStoettedeSigneringsmetoder;
                return this.skalSigneresAvBruker;
            });
    }

    private kalkulerStøtterPreview() {
        return this.dokument.virussjekkStatus != l.VirussjekkStatus.infisert
            && this.dokument.harPdfRepresentasjon;
    }

    private kalkulerForsidetype() {
        if (this.dokumentinformasjon.infisert) return "infisert";
        if (this.dokumentinformasjon.virussjekkPaagaar) return "virussjekk";
        if (this.dokument.forsideBildeId && this.visForsideBilde !== false) return "forside";
        return "ikon";
    }

    private oppdaterDokumentTilSenesteVersjon() {
        this.dokumentRes.hentGjeldendeDokumentversjon(this.dokument.dokumentId).$promise
            .then(sisteDokumentversjon => {
                this.initData(sisteDokumentversjon);
            });
    }

    private erSkjermbartSaksdokument(){
        return _([DokumentType.opplastetSaksdokument, DokumentType.arkivdokumentISak, DokumentType.generertAgendaDokument, DokumentType.generiskDokument]).includes(this.dokument.type);
    }

    private scrollTilPreview() {
        //må kjøres async for å få effekt
        this.$timeout(() => {scrollTilTopp(this.$element.find('.sls-dokument'))}, 100);
    }

    private markerDokumentSomLest() {
        this.dokument.erLestAv = true;
        this.saksdokumentDatatjenesteForAjs.tjeneste().then(saksdokumentDatatjeneste =>
          saksdokumentDatatjeneste.markerSomLestILokallager(this.dokument.dokumentId));
    }

    private åpneIPdfjs(){
        const url = this.dokumentRes.pdfjsDokumentViserUrl(this.dokument);
        debug('åpner med pdfjs', url);
        window.open(url, "_blank");
    }

    private lyttTilPdfjsÅpneINyttVindu() {
        if (this.pdfjsMeldingshåndteringRegistrert) return;
        this.pdfjsMeldingshåndteringRegistrert = true;
        this.pdfjsMeldingshåndtering.vedÅpneINyttVinduMelding(this.dokument.id, this.$scope, (melding: PdfjsMelding) => {
            debug('i lyttTilPdfjsÅpneINyttVindu', melding)
            this.åpneIPdfjs();
            this.lukkPreview();
        });
    }

    //modelloppdateringslyttere

    private lyttTilDokumentVirussjekket() {
        this.modelloppdatering.vedDokumentVirussjekket(
          info => this.dokument.id === info.dokumentVersjonId,
          this.$scope,
          info => this.dokumentRes.hentDokumentVersjon(info.dokumentVersjonId).$promise.then(dokumentVersjon => this.initData(dokumentVersjon)));
    }

    private lyttTilDokumentKonvertertPdf() {
        this.modelloppdatering.vedDokumentKonvertertPdf(
          info => this.dokument.id === info.dokumentVersjonId,
          this.$scope,
          info => this.dokumentRes.hentDokumentVersjon(info.dokumentVersjonId).$promise.then(dokumentVersjon => this.initData(dokumentVersjon)));
    }

    private lyttTilDokumentForsidebildeOpprettet() {
        this.modelloppdatering.vedDokumentForsidebildeOpprettet(
          info => this.dokument.id === info.dokumentVersjonId,
          this.$scope,
          info => this.dokumentRes.hentDokumentVersjon(info.dokumentVersjonId).$promise.then(dokumentVersjon => this.initData(dokumentVersjon)));
    }

    private lyttTilNyDokumentAnnotering() {
        this.modelloppdatering.vedNyDokumentAnnotering(
            info => this.dokument.id === info.dokumentVersjonId,
            this.$scope,
            info => this.dokument.antallAnnotasjoner++);
    }

    private lyttTilDokumentAnnoteringSlettet() {
        this.modelloppdatering.vedDokumentAnnoteringSlettet(
            info => this.dokument.id === info.dokumentVersjonId,
            this.$scope,
            info => this.dokument.antallAnnotasjoner--);
    }

    private lyttTilDokumentTilSignering() {
        this.modelloppdatering.vedDokumentTilSignering(
            info => this.dokument.dokumentId === info.dokumentId,
            this.$scope,
            info => this.oppdaterDokumentTilSenesteVersjon());
    }

    private lyttTilDokumentKomplettSignert() {
        this.modelloppdatering.vedDokumentKomplettSignert(
            info => this.dokument.dokumentId === info.dokumentId,
            this.$scope,
            info => this.oppdaterDokumentTilSenesteVersjon());
    }

    private lyttTilDokumentLåstOpp() {
        this.modelloppdatering.vedDokumentLåstOpp(
            info => this.dokument.dokumentId === info.dokumentId,
            this.$scope,
            info => this.oppdaterDokumentTilSenesteVersjon());
    }
}




